// Decimal-safe rounding shared by the simulators (spreadsheet behaviour: the value is
// reduced to 15 significant digits and halves are rounded away from zero).

// Shift the decimal point of x by d places without binary multiplication errors
function shift(x, d) {
  const [mantissa, exponent] = x.toExponential().split("e");
  return Number(`${mantissa}e${Number(exponent) + d}`);
}

// ROUND(x, d): halves away from zero, applied to the decimal value of x
// (x is first reduced to 15 significant digits, like a spreadsheet does).
export function round(x, d) {
  if (x === 0 || !Number.isFinite(x)) return x;

  // Fast path: when the scaled value is clearly away from a half, plain binary
  // rounding gives the same result as the decimal rounding below.
  const scale = Math.pow(10, d);
  const scaled = Math.abs(x) * scale;
  if (scaled < 1e12) {
    const fraction = scaled - Math.floor(scaled);
    if (Math.abs(fraction - 0.5) > 0.01) return (Math.sign(x) * Math.round(scaled)) / scale;
  }

  const abs = Number(Math.abs(x).toPrecision(15));
  return Math.sign(x) * shift(Math.round(shift(abs, d)), -d);
}

// INT(x): largest whole number not greater than x
export function int(x) {
  return Math.floor(Number(x.toPrecision(15)));
}
